(function () {
  document.querySelectorAll('[data-panel]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var panel = document.getElementById(tab.dataset.panel);
      if (!panel) return;
      var group = panel.parentNode;
      group.querySelectorAll('[data-panel]').forEach(function (t) { t.classList.remove('active'); });
      Array.prototype.forEach.call(group.children, function (child) {
        if (child.id) child.classList.remove('active');
      });
      tab.classList.add('active');
      panel.classList.add('active');
    });
  });
})();
